<style scoped>
    .v-application ol, .v-application ul {
        padding-left: 0px!important;
    }
    .context-menu {
        position: absolute;
        list-style: none;
        background-color: #f5f5f5;
        display: block;
        transition: box-shadow 0.1s;
        border-radius: 5px;
        text-decoration: none;
        border: solid 1px;
    }
    .context-menu li {
        display: block;
        width: 100%;
        padding: 5px 20px 5px 8px;
    }
    .context-delete {
        color: red;
    }
    .context-delete:hover {
        background-color: #C0C0C0;
    }
    .context-rename:hover {
        background-color: #C0C0C0;
    }
</style>
<template>
    <ul class="context-menu" :style="pagePos">
        <li class="context-delete" @click="clickDelete"><v-icon left>mdi-delete</v-icon>削除</li>
        <li class="context-rename" @click="clickRename"><v-icon left>mdi-pencil</v-icon>名前変更</li>
    </ul>
</template>
<script>
export default {
    data() {
        return {
            // コンテキストメニューの位置
            menuPosition: {
                left: 0,
                top: 0
            },
        }
    },
    props: {
        pagePos: Object,
    },
    methods: {
        clickDelete() {
            // 親コンポーネントへの通知
            this.$emit('clickDelete', true);
        },
        clickRename() {
            // 親コンポーネントへの通知
            this.$emit('clickRename', true);
        },
    },
}
</script>